import { createSlice } from "@reduxjs/toolkit";
import System from "../../../helper/system";
import $ from "jquery";
import Helper from "src/helper/Helper";

const setAllToURL = (data = {}) => {
  data = JSON.parse(JSON.stringify(data));
  let l = getAllFromURL();
  l.go = Helper.safeBase64Encode(data);
  // l.go = btoa(JSON.stringify(data));
  // bellow code snippet is regarding conversion of data in query string.
  // l.go = new URLSearchParams(JSON.stringify(data)).toString();

  if (l.go === "e30=") {
    delete l.go;
  }
  history.replaceState(null, null, "?" + $.param(l));
};

const getAllFromURL = (l = false) => {
  function paramsToObject(entries) {
    const result = {};
    for (const [key, value] of entries) {
      result[key] = value;
    }
    return result;
  }

  if (!l) {
    l = System.getParams();
  }
  if (l.go !== undefined && l.go) {
    try {
      // const urlParams = new URLSearchParams(l.go);
      // const entries = urlParams.entries();
      const params = Helper.safeBase64Decode(l.go);
      // const params = JSON.parse(atob(l.go));
      // const params = JSON.parse(Object.keys(paramsToObject(entries))[0]);
      l.go = params;
    } catch (e) {
      l.go = {};
    }
  } else {
    l.go = {};
  }
  return l;
};

const slice = createSlice({
  name: "ProductListingFilterApplied",
  initialState: getAllFromURL().go,
  reducers: {
    loadData: {
      reducer: (state, action) => {
        state.data = action.payload.data;
        setAllToURL(state.data);
      },
    },
    applyFilterByMainKeyAndSlug: {
      reducer: (state, action) => {
        let h = {};
        let category_filter_applied_detected = false;
        if (action.payload.key === "Categories") {
          category_filter_applied_detected = true;
        }
        if (state[action.payload.key] !== undefined) {
          h = state[action.payload.key];
        }
        if (category_filter_applied_detected) {
          if (h.main_label !== undefined) {
            h = {};
          }
        }
        let adder = {
          value: action.payload.value,
        };
        if (action.payload.hidden_payload !== undefined) {
          adder.hidden_payload = action.payload.hidden_payload;
        }
        if (h.s !== undefined) {
          let old_s = h.s;
          old_s.push(adder);
          h.s = old_s;
        } else {
          if (adder.hidden_payload !== undefined) {
            h.s = [
              {
                value: adder.value,
                hidden_payload: adder.hidden_payload,
              },
            ];
          } else {
            h.s = [
              {
                value: adder.value,
              },
            ];
          }
        }
        /* ref
                    This is to know what can be expected from payload
                    this will come at any cost
                    action.payload.key;
                    action.payload.main_label;
                    action.payload.selection.value;*/
        h.main_label = action.payload.main_label;
        state[action.payload.key] = h;
        setAllToURL(state);
        return state;
      },
    },
    clearFilterByKey: {
      reducer: (state, action) => {
        delete state[action.payload.key];
        setAllToURL(state);
        return state;
      },
    },
    clearFilterByKeyAndSelectionIndex: {
      reducer: (state, action) => {
        let pureStateClone = JSON.parse(JSON.stringify(state));
        let selection = pureStateClone[action.payload.key].s.filter(
          (v, i) => {
            if (action.payload.selectionIndex !== i) {
              return v;
            }
          }
        );
        if (selection.length === 0) {
          delete state[action.payload.key];
        } else {
          state[action.payload.key].s = selection;
        }
        setAllToURL(state);
        return state;
      },
    },
    clearAllFilter: {
      reducer: (state) => {
        state = {};
        setAllToURL(state);
        return state;
      },
    },
  },
});
export let {
  applyFilterByMainKeyAndSlug,
  loadData,
  clearAllFilter,
  clearFilterByKey,
  clearFilterByKeyAndSelectionIndex,
} = slice.actions;

export default slice.reducer;
